import { render, staticRenderFns } from "./gaming-communities.vue?vue&type=template&id=bbb2f980&scoped=true"
import script from "./gaming-communities.vue?vue&type=script&lang=js"
export * from "./gaming-communities.vue?vue&type=script&lang=js"
import style0 from "./gaming-communities.vue?vue&type=style&index=0&id=bbb2f980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb2f980",
  null
  
)

export default component.exports